import { RequirementAttachmentListRequest as AttachmentListRequestDto, RequirementAttachmentRequest as AttachmentRequestDto, RequirementAttachmentResponse } from "lib-klab-sdks";
import { RequirementAttachment, RequirementAttachmentListRequest, RequirementAttachmentRequest } from "../../../domain/models/requirement/requirement-attachment.model";

export function mapRequirementAttachment(source: RequirementAttachmentResponse): RequirementAttachment {
  return {
    id: source.requirementAttachmentId,
    requirementId: source.requirementId,
    attachmentType: source.attachmentType,
    fileUrl: source.fileUrl,
    fileName: source.fileName,
    uploadedBy: source.uploadedBy,
    createdAt: source.createdAt,
    deletedAt: source.deletedAt,
    deletedBy: source.deletedBy,
  };
}

export function mapRequirementAttachmentRequest(request: RequirementAttachmentRequest): AttachmentRequestDto {
  return { attachmentType: request.attachmentType, fileUrl: request.fileUrl, fileName: request.fileName };
}

export function mapRequirementAttachmentListRequest(request: RequirementAttachmentListRequest): AttachmentListRequestDto {
  return { attachmentType: request.attachmentType, includeDeleted: request.includeDeleted };
}
